"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _client = require("@apollo/client");
var _excluded = ["children", "query"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * @deprecated
 * Official support for React Apollo render prop components ended in March 2020.
 * This component is now provided by the @sm/apollo-clients package for backwards compatibility,
 * but it will not receive any feature updates or bug fixes.
 * You should use the `useQuery` hook instead.
 */
var Query = function Query(props) {
  var children = props.children,
    query = props.query,
    options = _objectWithoutProperties(props, _excluded);
  var result = (0, _client.useQuery)(query, options);
  return result ? children(result) : null;
};
var _default = exports.default = Query;
module.exports = exports.default;
//# sourceMappingURL=Query.js.map